<template>
  <div>
      <b-row>
        <!-- Field: First Name -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Nama</h5>
            <p>{{ (userData.name) ? userData.name : "-"}}</p>
        </b-col>

        <!-- Field: Email -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Email</h5>
            <p>{{ userData.email }}</p>
        </b-col>

        <!-- Field: No. Tel -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>No. Tel</h5>
            <p>{{ userData.phone }}</p>
        </b-col>

        <!-- Field: Address -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Alamat</h5>
            <p>{{ userData.address }}</p>
        </b-col>

        <!-- Field: Address -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Gereja</h5>
            <p>{{ (userData.church) ? "GPIB " + userData.church.name + " - " + userData.church.mupel.mupel : userData.church_name }}</p>
        </b-col>

        <!-- Field: Status -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Status</h5>
            <p>
                <b-badge :variant="statusVariant(userData.email_verified_at)">
                    {{ (userData.email_verified_at !== null) ? 'Diverifikasi' : 'Belum Diverifikasi'  }}
                </b-badge>
            </p>
        </b-col>

        <!-- Field: Role -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Role</h5>
            <p>
                <b-badge :variant="roleVariant(userData.roles)" v-if="userData.roles !== undefined && userData.roles.length > 0">
                    {{ userData.roles[0].name }}
                </b-badge>
            </p>
        </b-col>

        <!-- Field: Photo -->
        <b-col
          cols="12"
          md="4"
        >
          <h5>Photo</h5>
            <p v-if="!userData.photo">-</p>
            <div>
              <b-img width="120" v-if="userData.photo" :src="userData.photo" fluid thumbnail />
            </div>
        </b-col>
      </b-row>

  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BBadge, BImg
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BBadge,
    BImg
  },
  data() {
    return {
      isLoading: false,
    }
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    statusVariant(emailVerifiedAt) {
      return emailVerifiedAt !== null ? 'light-success' : 'light-danger'
    },
    roleVariant(roles) {
      if(roles === undefined || roles === null) {
        return 'light-info'
      }

      if(roles.length > 0) {
        if(roles[0].name == "Super Admin") {
          return 'light-primary'
        }
        else 
        if(roles[0].name == "Admin") {
          return 'light-primary'
        }
        else
        if(roles[0].name == "User") {
          return 'light-warning'
        }
        else {
            return 'light-info'
        }
      }
      else {
        return 'light-info'
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
